export default (matrixValues, _x, _y) => {
    return {
        x: matrixValues[0] * _x + matrixValues[2] * _y,
        y: matrixValues[1] * _x + matrixValues[3] * _y
    }
}